/**
 * @generated SignedSource<<4c9077b253bda3d03b875d76b6cb3cbe>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoTimelineUpdateEventRole_role$data = {
  readonly name: string;
  readonly " $fragmentType": "TodoTimelineUpdateEventRole_role";
};
export type TodoTimelineUpdateEventRole_role$key = {
  readonly " $data"?: TodoTimelineUpdateEventRole_role$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoTimelineUpdateEventRole_role">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoTimelineUpdateEventRole_role",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "EmployeeRole",
  "abstractKey": null
};

(node as any).hash = "18706406754210bd32e6e4ef1586a693";

export default node;
